import { NumericValue } from '../math/Decimal';
import { formatNumericValue } from './numberFormatter';

export const formatMoney = (value: NumericValue): string => `$${formatNumericValue(value)}`;
